<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import CustomPaginate from "../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
	import { navigate } from "svelte-routing";

	export let data;
	export let handleStatusChange;
	export let taskCategories;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Task Reference Id</th>
				<th>Description</th>
				<th>Task Type</th>
				<th>Image Upload</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { code, description, id, isActive, requireMediaUpload, requireOperatorRemarks, taskCategoryId }}
				<tr>
					<td>
						<p>
							<span
								class="link link-text"
								on:click={() =>
									navigate(`/master-data/preset-task/${id}`)}
							>
								{code}
							</span>
						</p>
					</td>
					<td>
						{description}
					</td>
					<td>
						{(taskCategories.length &&
							taskCategories.find(
								(category) => category.value === taskCategoryId
							).label) ||
							""}
					</td>
					<td>
						{#if requireMediaUpload}
							<p>Yes</p>
						{:else}
							<p>No</p>
						{/if}
					</td>
					<td>
						{#if isActive}
							<p class="status-bar status-bar-1">Active</p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							{#if isActive}
								<!-- This endpoint needs presetTaskId not returned by fetch api -->
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
